import script from "./DealerCreditProfileTabs.vue?vue&type=script&lang=ts&setup=true"
export * from "./DealerCreditProfileTabs.vue?vue&type=script&lang=ts&setup=true"

import "./DealerCreditProfileTabs.vue?vue&type=style&index=0&id=2382866d&scoped=true&lang=scss"

import exportComponent from "/data/code/front/deli-front-widget/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2382866d"]])

export default __exports__